//  █████╗  ██████╗████████╗██╗ ██████╗ ███╗   ██╗███████╗    ████████╗██╗   ██╗██████╗ ███████╗███████╗
// ██╔══██╗██╔════╝╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝    ╚══██╔══╝╚██╗ ██╔╝██╔══██╗██╔════╝██╔════╝
// ███████║██║        ██║   ██║██║   ██║██╔██╗ ██║███████╗       ██║    ╚████╔╝ ██████╔╝█████╗  ███████╗
// ██╔══██║██║        ██║   ██║██║   ██║██║╚██╗██║╚════██║       ██║     ╚██╔╝  ██╔═══╝ ██╔══╝  ╚════██║
// ██║  ██║╚██████╗   ██║   ██║╚██████╔╝██║ ╚████║███████║       ██║      ██║   ██║     ███████╗███████║
// ╚═╝  ╚═╝ ╚═════╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝       ╚═╝      ╚═╝   ╚═╝     ╚══════╝╚══════╝
export const Actions = {
  GET_USER_TASKS: "getUserTasks",
  GET_USER_PROFILE: "getUserProfile",
  GET_SURVEY_PROFILE: "getSurveyProfile"
};

/* eslint-disable max-len */

// ███╗   ███╗██╗   ██╗████████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗    ████████╗██╗   ██╗██████╗ ███████╗███████╗
// ████╗ ████║██║   ██║╚══██╔══╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║    ╚══██╔══╝╚██╗ ██╔╝██╔══██╗██╔════╝██╔════╝
// ██╔████╔██║██║   ██║   ██║   ███████║   ██║   ██║██║   ██║██╔██╗ ██║       ██║    ╚████╔╝ ██████╔╝█████╗  ███████╗
// ██║╚██╔╝██║██║   ██║   ██║   ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║       ██║     ╚██╔╝  ██╔═══╝ ██╔══╝  ╚════██║
// ██║ ╚═╝ ██║╚██████╔╝   ██║   ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║       ██║      ██║   ██║     ███████╗███████║
// ╚═╝     ╚═╝ ╚═════╝    ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝       ╚═╝      ╚═╝   ╚═╝     ╚══════╝╚══════╝

export const Mutations = {
  SET_USER_TASKS: "setUserTasks",
  SET_MOBILE: "setMobile",
  SET_TABLET: "setTablet",
  SET_DESKTOP: "setDesktop",
  SHOW_SPINNER: "showSpinner",
  HIDE_SPINNER: "hideSpinner",
  UPDATE_CAMPAIGN: "updateCampaign",
  SET_USER_PROFILE: "setUserProfile",
  SET_SURVEY_PROFILE: "setSurveyProfile"
};
